import { ReqPeriod } from 'src/models/reqPeriod.model';
import { dateToDateString } from './date.tools';
import { t } from './text.tools';
import { ID, Maybe } from 'src/models';

const TXT = t(['reqPeriod']);

export function toReqNumber(id: Maybe<ID>) {
  if (typeof id === 'undefined') return '';

  return String(id).padStart(3, '0');
}

export function renderReqPeriodDates({ start_date, end_date, is_current_period }: ReqPeriod) {
  const start = is_current_period && !start_date ? TXT('noDate') : dateToDateString(start_date);

  const end = is_current_period && !end_date ? TXT('today') : dateToDateString(end_date);

  return start || end ? `${start} - ${end || TXT('noDate')}` : TXT('noDates');
}

export function renderReqPeriodLabel(period?: ReqPeriod) {
  if (!period) return '–';

  return `${period.name}: ${renderReqPeriodDates(period)}`;
}
